import React, {useState} from 'react';
import {currentUser, duckify} from "utils/duckify";
import {exportConfigs as exportConfigsDuck, modals, savedSearches, flashMessages} from "ducks";
import ModalComponent from "../ModalComponent";
import ModalRoot from "../ModalRoot";
import {pastOptions, futureOptions} from '../../hocs/withDateFilter';
import FlashRoot from "../FlashMessage/FlashRoot";
import {Button} from "react-bootstrap";
import {titleize} from '../../utils/strings';
import CustomerNote from "./CustomerNote";
import Placeholder from '../Placeholder';
import moment from 'moment/moment';
import { formattedDate } from '../../utils';
import DatePicker from 'react-datepicker';

const ExportConfig = ({allDucksReady, exportConfigs, dispatch, searches, currentUser}) => {
  const downloadFile = (exportConfigId) => {
    dispatch(modals.actions.show('Downloader', {
      url: `/api/export_configs/${exportConfigId}`,
      async: false,
      httpMethod: "get"
    }))
  }

  if (allDucksReady) {
    return (<div>
      <CustomerNote isSuperAdmin={'true'} userName={currentUser.name} pageName={'export_configs'}/>
      <ModalRoot modals={{ExportConfigModal}}/>
      <div>
        <h2 className="inline">
          Export Configurations
        </h2>
      </div>
      <div className="row">
        <div className="col-24">
          <a href='#' onClick={() => dispatch(modals.actions.show('ExportConfigModal', {searches: searches, dispatch: dispatch}))}
             className={'add-item-button'}><i className="fa fa-plus-circle"/> Add a new export
            configuration</a>
        </div>
      </div>

      <table className="table table-striped crud-table table-align-top">
        <thead>
        <tr>
          <th><a title="Name">Name</a></th>
          <th><a title="Type">Type</a></th>
          <th>Search</th>
          <th>Which records</th>
          <th>Hidden</th>
          <th>Date Range</th>
          <th>Date Type</th>
          <th>Params File</th>
          <th><a title="Last Edit">Last Edit</a></th>
          <th>Edit History</th>
          <th></th>
        </tr>
        </thead>
        <tbody>

        {exportConfigs.map((config) =>
          <tr key={config.id}>
            <td>{config.name}</td>
            <td>{config.exported_for}</td>
            <td><a href='#' target='_blank' href={`/search/${config.search_id}`}>{config.search_name}</a></td>
            <td>{config.export_type}</td>
            <td>{config.hidden ? "Yes" : "No"}</td>
            <td>{titleize(config.date_range)}</td>
            <td>{titleize(config.date_type)}</td>
            <td><a href='#' onClick={() => downloadFile(config.id)}>Download</a></td>
            <td>{config.updated_at}</td>

            <td><a href={'#'} onClick={() => dispatch(modals.actions.show('AuditViewer', {
              id: config.id, resource: 'export_configs'
            }))}>View Changes</a></td>
            <td><a href='#' onClick={() => dispatch(modals.actions.show('ExportConfigModal', {
              exportConfig: config,
              searches: searches,
              dispatch: dispatch
            }))}>Edit</a>
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </div>)
  } else {
    return (<Placeholder.loading></Placeholder.loading>)
  }
}

const ExportConfigModal = ({exportConfig = {}, searches, dispatch}) => {
  const [config, setConfig] = useState(exportConfig);
  const [paramFile, setParamFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const updateConfig = (e) => {
    const modifiedConfig = {...config};

    if(e.currentTarget.name == 'hidden') {
      modifiedConfig[e.currentTarget.name] = e.currentTarget.checked;
    } else {
      modifiedConfig[e.currentTarget.name] = e.currentTarget.value;
    }
    setConfig(modifiedConfig);
  }

  const updateStartEnd = (field, date) => {
    const modifiedConfig = {...config};

    modifiedConfig[field] = date;
    setConfig(modifiedConfig);
  }

  const onSubmit = () => {
    setSaving(true)
    dispatch(exportConfigsDuck.actions.update({exportConfig: config, paramFile: paramFile}))
      .then(() => dispatch(exportConfigsDuck.actions.markDirty()))
      .then(() => dispatch(modals.actions.hide()))
      .catch((response) => dispatch(flashMessages.actions.show({
        message: Object.keys(response.export_config.errors).map((key) => <div>{response.export_config.errors[key]}</div>),
        type: 'danger',
        dismissible: true
      }))).then(() => setSaving(false))
  }

  const dateOptions = [...futureOptions, ...pastOptions]
  const nonContactExports = ['BillingExport', 'PayoutExport', 'FeNXTExport', 'QuickbooksExport'];

  // Modal for editing and creating new export configurations
  return (<ModalComponent onClose={() => dispatch(modals.actions.hide())} title={'Export Configuration Details'}
                          buttons={[<Button disabled={saving} onClick={onSubmit} className="btn btn-primary">Submit</Button>]}>

    <form className={'form form-horizontal'}>
      <FlashRoot />
      <div className="mb-3 row">
        <label className="form-label col-form-label text-end">
          Name
        </label>
        <div className="controls">
          <input type="text" name="name" defaultValue={config.name} onChange={(e) => updateConfig(e)}/>
        </div>
      </div>

      <div className="mb-3 row">
        <label className="form-label col-form-label text-end">
          Type
        </label>
        <div className="controls">
          <select defaultValue={config.exported_for}  name="exported_for"  onChange={(e) => updateConfig(e)} >
            <option value="" label=" "></option>
            <option value="BlackbaudApiExport">BlackbaudApiExport (deprecated)</option>
            <option value="BlackbaudSchoolExport">BlackbaudSchoolExport</option>
            <option value="BillingExport">BillingExport</option>
            <option value="FeNXTExport">FeNXTExport</option>
            <option value="FormExport">FormExport</option>
            <option value="PayoutExport">PayoutExport</option>
            <option value="PowerSchoolApiExport">PowerSchoolApiExport</option>
            <option value="QuickbooksExport">QuickbooksExport</option>
            <option value="SwissArmyExport">SwissArmyExport</option>
            <option value="VeracrossApiExport">VeracrossApiExport</option>
          </select>
        </div>
      </div>

      {!nonContactExports.includes(config.exported_for) &&
      <React.Fragment>
        <div className="mb-3 row">
          <label className="form-label col-form-label text-end">
            Search
          </label>
          <div className="controls">
            <select defaultValue={config.search_id} name="search_id" onChange={(e) => updateConfig(e)}>
              <option value="" label=" "></option>
              {searches.map((search) => <option key={search.id} value={search.id}>{search.name}</option>)}
            </select>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="form-label col-form-label text-end">
            Which records
          </label>
          <div className="controls">
            <select defaultValue={config.export_type} name="export_type" onChange={(e) => updateConfig(e)}>
              <option value="" label=" "></option>
              <option value="all">All records</option>
              <option value="new">Since last export</option>
            </select>
          </div>
        </div>
      </React.Fragment>}


      {nonContactExports.includes(config.exported_for) && <React.Fragment>
        <div className="mb-3 row">
          <label className="form-label col-form-label text-end">
            Date Type
          </label>
          <div className="controls">
            <select defaultValue={config.date_type}  id="date_type" name="date_type" onChange={(e) => updateConfig(e)}>
              <option value="" label=" "></option>
              <option value={"created_at"}>Created At</option>
              <option hidden={config.exported_for === 'PayoutExport'} disabled={config.exported_for === 'PayoutExport'} value={"billing_date"}>Billed On</option>
              <option hidden={config.exported_for === 'PayoutExport'} disabled={config.exported_for === 'PayoutExport'} value={"payout_date"}>Payed Out On</option>
            </select>
          </div>
        </div>

        <div className="mb-3 row">
          <label className="form-label col-form-label text-end">
            Date Range
          </label>
          <div className="controls">
            <select defaultValue={config.date_range} name="date_range" onChange={(e) => updateConfig(e)}>
              <option value="" label=" "></option>
              {dateOptions.map((range) => <option value={range[1]}>{range[0]}</option>)}
            </select>
          </div>
        </div>

        {config.date_range === 'custom' && <React.Fragment>
          <div className="mb-3 row">
            <label className="form-label col-form-label text-end">
              Start Date
            </label>
            <div className="controls">
              <DatePicker
                name='start_date'
                dateFormat={global.I18n.date.formats.default_date_fns}
                showPopperArrow
                popperPlacement='top-end'
                selected={config.start_date == null ? '' : moment(config.start_date).toDate()}
                onChange={(date) => updateStartEnd('start_date', date)}
              />
            </div>
          </div>
          <div className="mb-3 row">
            <label className="form-label col-form-label text-end">
              End Date
            </label>
            <div className="controls">
              <DatePicker
                name='end_date'
                dateFormat={global.I18n.date.formats.default_date_fns}
                showPopperArrow
                popperPlacement='top-end'
                selected={config.end_date == null ? '' : moment(config.end_date).toDate()}
                onChange={(date) => updateStartEnd('end_date', date)}
              />
            </div>
          </div>
        </React.Fragment>
        }
      </React.Fragment>
      }

      <div className="mb-3 row">
        <label className="form-label col-form-label text-end">
          Hidden
        </label>
        <div className="controls">
          <input id='config_hidden' type="checkbox" name="hidden" defaultChecked={config.hidden} onChange={(e) => updateConfig(e)}/>
        </div>
      </div>

      <div className="mb-3 row">
        <label className="form-label col-form-label text-end">
          Parameter File
        </label>
        <div className="controls">
          <input type="file" name="params" onChange={(e) => setParamFile(e.target.files[0])}/>
        </div>
      </div>

    </form>

  </ModalComponent>)
}



const mapDucksToProps = () => ({ exportConfigs: exportConfigsDuck, searches: savedSearches, currentUser});

export default duckify(mapDucksToProps)(ExportConfig);
